import React from "react";
import { inject, observer } from "mobx-react";
import { FormControl, InputLabel, Select, MenuItem } from "@material-ui/core";
import { DEFAULT_UNSET_WATERMARK } from "../httpClients/ClippyApi";

// Watermarks returned as filenames  or "None" (default)
// Helper method to format for readability (e.g. "xyz.png" -> "XYZ")
const formatWatermarkName = name =>
  name !== DEFAULT_UNSET_WATERMARK ? name.split(".")[0].toUpperCase() : name;

class WatermarkFormItem extends React.Component {
  render() {
    const { handleOnChange, value, watermarkStore } = this.props;

    return (
      <FormControl fullWidth>
        <InputLabel htmlFor="watermark">Watermark</InputLabel>
        <Select
          value={value || watermarkStore.watermarks[0]}
          onChange={e => handleOnChange(e.target.value)}
          inputProps={{
            name: "Watermark",
            id: "watermark"
          }}
        >
          {watermarkStore.watermarks.map((watermark, i) => (
            <MenuItem key={i} value={watermark}>
              {formatWatermarkName(watermark)}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    );
  }
}

export default inject("watermarkStore")(observer(WatermarkFormItem));



// WEBPACK FOOTER //
// ./src/components/WatermarkFormItem.js